import { jsx as e, jsxs as m } from "react/jsx-runtime";
import { c as t } from "./clsx.OuTLNxxd.js";
import { NeuBreadcrumb as a } from "@hcahealthcaredpx/neutron-react";
import { u as w } from "./use-sitecore-context.C7g4vcbm.js";
import { S as I } from "./Section.SS-Irndy.js";
const q = ({
  dataTestId: c,
  // isLarge = true, // todo - may need to add logic back for large bottom padding
  className: B,
  title: f,
  breadcrumbs: N,
  withBreadcrumbs: v,
  children: j,
  applyCorporateStyles: i = !1
}) => {
  var g, p;
  const { sitecoreContext: s } = w(), k = ((p = (g = s == null ? void 0 : s.theme) == null ? void 0 : g.entityBrandingOverrides) == null ? void 0 : p.pageTitleBanner) || "main-100", x = (s == null ? void 0 : s.breadcrumbs) || [], o = {
    text: f == null ? void 0 : f.value
  }, l = N || (o != null && o.text ? [...x, o] : x), h = i ? "pb-6" : null;
  return /* @__PURE__ */ e(
    I,
    {
      dataTestId: c,
      disableContainer: i,
      className: t(
        "w-100 d-flex py-6",
        i ? "neu-bg-main-0 px-2 px-lg-6" : `neu-bg-${k}`,
        B
      ),
      children: /* @__PURE__ */ e("div", { className: t("container gx-0", h), children: /* @__PURE__ */ m("div", { className: t("row gx-0", h), children: [
        v ? /* @__PURE__ */ e(
          a,
          {
            className: t(
              "d-none d-lg-flex",
              i ? "breadcrumbs-dark" : "breadcrumbs-light"
            ),
            children: l == null ? void 0 : l.map((n) => /* @__PURE__ */ e(
              a.Item,
              {
                ...(n == null ? void 0 : n.href) && { href: n.href },
                children: n == null ? void 0 : n.text
              },
              (n == null ? void 0 : n.href) || (n == null ? void 0 : n.text)
            ))
          }
        ) : null,
        j
      ] }) })
    }
  );
};
export {
  q as B
};
